/**
 * =============================================================================
 * Layout.tsx - Layout principale con sidebar verticale
 * =============================================================================
 * 
 * Layout globale che usa SidebarProvider + AppSidebar per la navigazione
 * verticale. Include header minimale con SidebarTrigger, area contenuto
 * principale e footer.
 * 
 * @author CCFN Development Team
 * =============================================================================
 */

import { ReactNode } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { Footer } from "./Footer";
import { DynamicTypographyStyles } from "@/components/DynamicTypographyStyles";
import { FloatingHelpButton } from "@/components/guide/FloatingHelpButton";
import { SearchHighlightBar } from "@/components/search/SearchHighlightBar";

interface LayoutProps {
  children: ReactNode;
  showFooter?: boolean;
}

export function Layout({ children, showFooter = true }: LayoutProps) {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full" data-tour-id="layout-root">
        <DynamicTypographyStyles />
        <AppSidebar />

        <div className="flex-1 flex flex-col min-w-0">

          <main className="flex-1" data-tour-id="main-content">
            {children}
          </main>

          {showFooter && <Footer />}
        </div>

        <FloatingHelpButton />
        <SearchHighlightBar />
      </div>
    </SidebarProvider>
  );
}
